import { FC, useContext, useEffect } from 'react'
import { MeetingStepStatus, MeetingStepViewId } from '../../../../types'
import { AppraisalFlowContext } from './AppraisalFlowProvider'

type AppraisalContextHelperProps = {
  stepViewId: MeetingStepViewId
  stepStatus: MeetingStepStatus
  callback?: () => void
}

export const AppraisalFlowHelper: FC<AppraisalContextHelperProps> = ({ stepViewId, stepStatus }) => {
  const { setCurrentStepState } = useContext(AppraisalFlowContext)

  useEffect(() => {
    setCurrentStepState({ viewId: stepViewId, status: stepStatus })
  }, [stepStatus, stepViewId, setCurrentStepState])

  return null
}
